// src/components/ModalHeader.js
import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";

export default function ModalHeader({ title, subtitle }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: alpha(theme.palette.primary.main, 0.05), // SAME AS SMARTTABLE HEADER
        px: 2,
        py: 1.8,
        borderTopLeftRadius: "16px",
        borderTopRightRadius: "16px",
        borderBottom: `2px solid ${theme.palette.primary.main}`, // EXACT SMARTTABLE BORDER
      }}
    >
      <Typography
        variant="h6"
        fontWeight={700}
        sx={{ color: theme.palette.primary.main }}
      >
        {title}
      </Typography>

      {subtitle && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 0.4 }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
